export const  chatTypes={
    DIRECT:"DIRECT",
    GROUP:"GROUP",
    CHANNEL:"CHANNEL",
    VOICE_CHANNEL:"VOICE_CHANNEL",
}

export const chatActions={
    SET_CHOSEN_CHAT_DETAILS:"CHAT.SET_CHOSEN_CHAT_DETAILS",
    SET_MESSAGES:"CHAT.SET_MESSAGES",
    SET_CHAT_TYPE:"CHAT.SET_CHAT_TYPE"
}
export const getActions=(dispatch)=>{
    return{
        setChosenChatDetails:(details,chatType)=>dispatch(setChosenChatDetails(details,chatType)),
        setMessages:(messages)=>dispatch(setMessage(messages))
    }
}
export const setChosenChatDetails=(chatDetails,type)=>{
    return {
        type:chatActions.SET_CHOSEN_CHAT_DETAILS,
        chatType:type,
        chatDetails
    }
}
export const setMessage=(messages)=>{
    return {
        type:chatActions.SET_MESSAGES,
        messages,
    }
}

export const appendMessage = (message) => {
    return {
        type: "CHAT.APPEND_MESSAGE",
        message,
    }
}
